import { ApiService } from '../services/api_service';
import { DataService } from '../services/data_service';
import { formStyle } from '../core/forms/WFormFramework';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as React from 'react';

export interface KontaktFaqProps {
    bereich?: string;
    onDataLoaded?: (data: any[]) => void;
    style?: React.CSSProperties;
    thema: number;
}

export interface KontaktFaqState {
    data: any[];
}

export class KontaktFaq extends React.Component<KontaktFaqProps, KontaktFaqState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: []
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(DataService) private dataService: DataService;

    private cache: any = {};

    componentDidMount(): void {
        this.setData();
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        if (prevProps.bereich !== this.props.bereich || prevProps.thema !== this.props.thema) {
            this.setData();
        }
    }

    async getData(entity: string, filter: any, settings: any): Promise<any[]> {
        return (await this.dataService.async_loadData(entity, filter, settings, IDs.MOD_ETOOL_ADMIN) || {})[entity] || [];
    }

    async setData(): Promise<void> {
        const { thema } = this.props;
        let faq: any[] = this.cache[thema] || [];

        if (!thema) {
            this.setState({ data: faq }, () => typeof this.props.onDataLoaded === 'function' && this.props.onDataLoaded(faq));
            return;
        }
        const zuordnung: any[] = !this.cache[thema] ? await this.getData(IDs.ENT_KONTAKT_FAQ_ZUORDNUNG, { thema }, {}) : [];

        if (zuordnung.length && !this.cache[thema]) {
            const bereiche: any = {};
            const tids: string = zuordnung.map((item: any) => {
                bereiche[item.faq] = item.bereich_key;
                return item.faq;
            }).join(',');
            // faq = await this.getData(IDs.ENT_KONTAKT_FAQ, [{ field: 'tid', op: 'IS NOT NULL', val: `AND tid IN (${tids})` }], {});
            faq = await this.getData(IDs.ENT_KONTAKT_FAQ, { tid: tids }, {});
            // console.log(faq, JSON.stringify(faq).length);
            faq.forEach((item: any) => item.bereich_key = bereiche[item.tid] || null);
        }
        const data: any[] = faq.filter((item: any) => !item.bereich_key || item.bereich_key === this.props.bereich);
        this.cache[thema] = faq;
        this.setState({ data }, () => typeof this.props.onDataLoaded === 'function' && this.props.onDataLoaded(data));
    }

    render(): JSX.Element {
        return (
            <div style={{ width: '100%', ...(this.props.style || {}) }}>
                {this.renderList()}
            </div>
        );
    }

    renderList(): JSX.Element[] {
        const { data } = this.state;

        return data.map((item: any, index: number) =>
            <React.Fragment key={`faq-${index}`}>
                <div
                    className={formStyle.formTitelLight}
                    style={{ textAlign: 'left', cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => {
                        item.isVisible = !item.isVisible;
                        this.setState({ data });
                    }}
                >
                    {item.frage} {item.isVisible ? <>&#9660;</> : <>&#9650;</>}
                </div>
                <div
                    style={{
                        paddingBlock: 4, display: 'grid', gridTemplateRows: item.isVisible ? '1fr' : '0fr',
                        transition: '0.25s grid-template-rows ease-in-out'
                    }}
                >
                    <div style={{ lineHeight: 1.1, textAlign: 'justify', padding: '0 4px', overflow: 'hidden' }}>
                        {item.antwort}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
